import {InjectionToken} from '@angular/core';

export interface AuthServiceConfig {
  urls: {
    accountOrigin: string
  };
}

export const AUTH_SERVICE_CONFIG = new InjectionToken<AuthServiceConfig>('');
